<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6" lg="4">
        <v-card class="pa-6">
          <v-card-title class="text-center text-h4 mb-4">
            Вход
          </v-card-title>

          <v-alert
            v-if="showAlert"
            :type="alertType"
            variant="tonal"
            closable
            class="mb-4"
            @click:close="showAlert = false"
          >
            {{ errorMessage }}
          </v-alert>

          <v-form @submit.prevent="handleSubmit">
            <v-text-field
              v-model="email"
              name="email"
              autocomplete="username"
              label="Почта"
              type="email"
              variant="outlined"
              required
              :rules="emailRules"
              class="mb-4"
            ></v-text-field>

            <v-text-field
              v-model="password"
              name="password"
              autocomplete="current-password"
              label="Пароль"
              type="password"
              variant="outlined"
              required
              :rules="passwordRules"
              class="mb-4"
            ></v-text-field>

            <v-btn
              type="submit"
              color="primary"
              size="large"
              block
              :loading="isLoading"
              class="mb-4"
            >
              {{ isLoading ? 'Вход...' : 'Вход' }}
            </v-btn>

            <v-row justify="center" class="mt-4">
              <v-col cols="auto">
                <router-link to="/signup" class="text-primary text-decoration-none">
                  Регистрация
                </router-link>
              </v-col>
              <v-col cols="auto">
                <router-link to="/restore-password" class="text-primary text-decoration-none">
                  Восстановление пароля
                </router-link>
              </v-col>
            </v-row>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import apiClient from '@/apiClient'
import { mapState } from "vuex";
import { forceAuthCleanup } from '@/utils/auth-cleanup';
import { idleLimitMinutes } from '@/utils/activity';

export default {
  data() {
    return {
      email: '',
      password: '',
      showAlert: false,
      // the automatic sign-out for inactivity is not an error: shown green
      alertType: 'error',
      errorMessage: '',
      isLoading: false,
      emailRules: [
        v => !!v || 'Почта обязательна',
        v => /.+@.+\..+/.test(v) || 'Почта должна быть валидной',
      ],
      passwordRules: [
        v => !!v || 'Пароль обязателен',
      ],
    };
  },
  methods: {
    async handleSubmit() {
      this.isLoading = true;
      const loginData = {
        email: this.email,
        password: this.password
      };

      try {
        const response = await apiClient.post('/login', loginData);
        
        if (response.status === 200) {
          // Handle new JWT response format
          const { access_token, expires_in, token_type, user } = response.data;
          
          // Use store action to handle login state
          await this.$store.dispatch('login', {
            access_token,
            expires_in, 
            token_type,
            user
          });
          
          this.$router.push('/dashboard');
        }
      } catch (error) {
        const status = error.response?.status;
        // Backend unreachable (restart / rebuild / gateway down): no HTTP
        // response at all, or a gateway-level error. Show maintenance notice
        // instead of a misleading "wrong login/password".
        const backendDown = !error.response || [502, 503, 504].includes(status);

        if (backendDown) {
          this.showError('На сайте ведутся технические работы. Мы скоро вернёмся.');
        } else if (error.response.data && error.response.data.detail) {
          const errorDetail = error.response.data.detail;
          this.showError(errorDetail);

          // Check if it's an unconfirmed email error
          if (typeof errorDetail === 'string' && errorDetail.includes('подтвержд')) {
            // Keep the error message visible longer for email confirmation issues
            this.showAlert = true;
          }
        } else {
          this.showError('Ошибка входа, пожалуйста попробуйте позже');
        }

        // Don't logout on login error - user is not logged in yet
        // this.$store.dispatch('logout'); // REMOVED - causes infinite loop
      } finally {
        this.isLoading = false;
      }
    },
    
    showError(errorMessage, type = 'error') {
      this.errorMessage = errorMessage;
      this.alertType = type;
      this.showAlert = true;
    },
    
    clearAuth() {
      forceAuthCleanup();
      // Reload page to clear all state
      window.location.reload();
    }
  },
  computed: {
    ...mapState({
      timeOut: state => state.timeOut,
      idleOut: state => state.idleOut,
      isLoggedIn: state => state.isLoggedIn
    }),
  },
  mounted() {
    if (this.idleOut) {
      this.showError(`Автоматический выход из системы: отсутствие действий в течение ${idleLimitMinutes()} минут. `
        + 'В целях безопасности, пожалуйста, войдите снова.', 'success');
      this.$store.commit('setIdleOut', false);
    } else if (this.timeOut) {
      this.showError('Выход по таймауту, пожалуйста зайдите снова');
      this.$store.commit('setTimeOut', false);
    }
  },
};
</script>

<style scoped>
/* Vuetify handles styling, minimal custom styles needed */
</style>